(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-slider"] && !Shopify.designMode) return;
  try {
    
  class AboutSlider extends HTMLElement {
        static get observedAttributes() {
          return ['data-speed', 'data-autoplay'];
        }

        attributeChangedCallback() {
          this.syncMotion();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          this.viewport = this.querySelector('[data-viewport]');
          this.track = this.querySelector('[data-track]');
          if (!this.viewport || !this.track) return;

          this.slides = Array.from(this.track.querySelectorAll('[data-slide]:not([data-clone])'));
          this.realCount = this.slides.length;
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.offset = this.offset || 0;
          this.lastTick = 0;
          this.hovering = false;
          this.gap = 5;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.labels = {
            play: this.dataset.playLabel || 'Play video',
            pause: this.dataset.pauseLabel || 'Pause video',
            mute: this.dataset.muteLabel || 'Mute video',
            unmute: this.dataset.unmuteLabel || 'Unmute video',
          };
          this.syncMotion();

          if (!this.bound) {
            this.bound = true;
            this.onResize = this.onResize.bind(this);
            this.onEnter = this.onEnter.bind(this);
            this.onLeave = this.onLeave.bind(this);
            this.onDotClick = this.onDotClick.bind(this);
            this.onPointerDown = this.onPointerDown.bind(this);
            this.onPointerMove = this.onPointerMove.bind(this);
            this.onPointerUp = this.onPointerUp.bind(this);
            this.onDragStart = this.onDragStart.bind(this);
            this.addEventListener('mouseenter', this.onEnter);
            this.addEventListener('mouseleave', this.onLeave);
            this.addEventListener('focusin', this.onEnter);
            this.addEventListener('focusout', this.onLeave);
            this.addEventListener('click', this.onDotClick);
            this.viewport.addEventListener('pointerdown', this.onPointerDown);
            this.viewport.addEventListener('dragstart', this.onDragStart);
            window.addEventListener('resize', this.onResize);
          }

          this.prepareLoop();
          this.bindVideos();
          this.applyTransform();
          this.syncDots();
          this.startLoop();
        }

        disconnectedCallback() {
          if (this.raf) cancelAnimationFrame(this.raf);
          this.stopDrag(true);
          window.removeEventListener('resize', this.onResize);
        }

        startLoop() {
          if (this.raf) cancelAnimationFrame(this.raf);
          const slider = this;
          const run = (now) => {
            slider.tick(now);
            slider.raf = requestAnimationFrame(run);
          };
          this.raf = requestAnimationFrame(run);
        }

        syncMotion() {
          this.autoplay = this.dataset.autoplay === 'true' && (this.realCount || 0) > 1;
        }

        currentSpeed() {
          const css = Number(getComputedStyle(this).getPropertyValue('--about-slider-speed'));
          if (Number.isFinite(css) && css > 0) return css;
          const attr = Number(this.dataset.speed);
          if (Number.isFinite(attr) && attr > 0) return attr;
          return 40;
        }

        onDotClick(event) {
          const dot = event.target.closest('[data-dot]');
          if (!dot || !this.contains(dot)) return;
          this.goTo(Number(dot.dataset.index) || 0);
        }

        prepareLoop() {
          if (this.realCount < 2) return;
          if (this.track.querySelector('[data-clone]')) return;
          this.slides.forEach((slide, i) => {
            const clone = slide.cloneNode(true);
            clone.removeAttribute('data-slide');
            clone.setAttribute('data-clone', '');
            clone.setAttribute('data-slide-index', String(i));
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('id');
            clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
            this.track.appendChild(clone);
          });
        }

        slideStep() {
          const slide = this.track.querySelector('[data-slide], [data-clone]');
          if (!slide) return 0;
          return slide.getBoundingClientRect().width + this.gap;
        }

        loopWidth() {
          return this.slideStep() * this.realCount;
        }

        applyTransform() {
          this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`;
        }

        wrapOffset() {
          const loop = this.loopWidth();
          if (!loop) return;
          this.offset = ((this.offset % loop) + loop) % loop;
        }

        onDragStart(event) {
          event.preventDefault();
        }

        onPointerDown(event) {
          if (this.realCount < 2) return;
          if (event.pointerType !== 'touch' && event.button !== 0) return;
          if (event.target.closest('[data-playback], [data-mute], [data-progress], [data-dot], button, a')) {
            return;
          }

          this.dragListening = true;
          this.dragging = false;
          this.dragMoved = false;
          this.pointerId = event.pointerId;
          this.dragStartX = event.clientX;
          this.dragStartY = event.clientY;
          this.dragStartOffset = this.offset;
          document.addEventListener('pointermove', this.onPointerMove, { passive: false });
          document.addEventListener('pointerup', this.onPointerUp);
          document.addEventListener('pointercancel', this.onPointerUp);
        }

        onPointerMove(event) {
          if (!this.dragListening || event.pointerId !== this.pointerId) return;

          const dx = event.clientX - this.dragStartX;
          const dy = event.clientY - this.dragStartY;

          if (!this.dragMoved) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
            if (Math.abs(dy) > Math.abs(dx)) {
              this.stopDrag(true);
              return;
            }
            this.dragMoved = true;
            this.dragging = true;
            this.classList.add('is-dragging');
            if (this.pointerId != null) {
              try {
                this.viewport.setPointerCapture(this.pointerId);
              } catch (error) {}
            }
          }

          event.preventDefault();
          this.offset = this.dragStartOffset - dx;
          this.wrapOffset();
          this.applyTransform();
          this.syncDots();
        }

        onPointerUp(event) {
          if (!this.dragListening) return;
          if (event && event.pointerId !== this.pointerId) return;
          this.stopDrag(false);
        }

        stopDrag() {
          if (!this.dragListening && !this.dragging) return;
          this.dragListening = false;
          this.dragging = false;
          this.classList.remove('is-dragging');
          this.lastTick = 0;
          if (this.pointerId != null) {
            try {
              this.viewport.releasePointerCapture(this.pointerId);
            } catch (error) {}
            this.pointerId = null;
          }
          document.removeEventListener('pointermove', this.onPointerMove);
          document.removeEventListener('pointerup', this.onPointerUp);
          document.removeEventListener('pointercancel', this.onPointerUp);
        }

        goTo(index) {
          const step = this.slideStep();
          const n = this.realCount || 1;
          const next = ((index % n) + n) % n;
          this.offset = next * step;
          this.applyTransform();
          this.syncDots();
        }

        syncDots() {
          const step = this.slideStep();
          const n = this.realCount || 1;
          const active = step ? Math.floor((this.offset + 0.5) / step) % n : 0;
          this.dots.forEach((dot, i) => {
            const on = i === active;
            dot.classList.toggle('is-active', on);
            if (on) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }

        tick(now) {
          const dt = this.lastTick ? now - this.lastTick : 0;
          this.lastTick = now;
          const speed = this.currentSpeed();
          const autoplay = this.dataset.autoplay === 'true' && this.realCount > 1;

          if (autoplay && !this.reduced && !this.hovering && !this.dragging && speed) {
            this.offset += (speed / 1000) * dt;
            const loop = this.loopWidth();
            if (loop && this.offset >= loop) this.offset -= loop;
            this.applyTransform();
            this.syncDots();
          }

          this.syncProgress();
          this.keepVideosPlaying();
        }

        onEnter() {
          this.hovering = true;
        }

        onLeave(event) {
          if (event && event.type === 'focusout' && this.contains(event.relatedTarget)) return;
          this.hovering = false;
          this.lastTick = 0;
        }

        onResize() {
          const step = this.slideStep();
          const n = this.realCount || 1;
          const active = step ? Math.floor((this.offset + 0.5) / step) % n : 0;
          this.offset = active * step;
          this.applyTransform();
        }

        wrapsForIndex(index) {
          return this.querySelectorAll(`[data-slide-index="${index}"] [data-video-wrap]`);
        }

        bindVideos() {
          this.querySelectorAll('[data-video-wrap]').forEach((wrap) => {
            if (wrap.dataset.bound === 'true') return;
            wrap.dataset.bound = 'true';

            const video = wrap.querySelector('video');
            if (!video) return;
            const slide = wrap.closest('[data-slide-index]');
            const index = slide ? slide.getAttribute('data-slide-index') : '0';
            const playback = wrap.querySelector('[data-playback]');
            const mute = wrap.querySelector('[data-mute]');
            const progress = wrap.querySelector('[data-progress]');
            const fill = wrap.querySelector('[data-progress-fill]');

            video.controls = false;
            video.playsInline = true;
            video.muted = true;
            video.loop = true;
            video.preload = 'auto';
            const poster = wrap.dataset.poster;
            if (poster) video.poster = poster;

            wrap.classList.add('is-muted');
            wrap.classList.remove('is-playing');

            const durationOf = () => {
              const duration = video.duration;
              return Number.isFinite(duration) && duration > 0 ? duration : 0;
            };

            const setProgress = (ratio) => {
              const value = Math.min(1, Math.max(0, ratio));
              if (fill) fill.style.setProperty('--progress', String(value));
              progress?.setAttribute('aria-valuenow', String(Math.round(value * 100)));
            };

            const syncPlaybackUi = (playing) => {
              wrap.classList.toggle('is-playing', playing);
              if (playback) {
                playback.setAttribute('aria-label', playing ? this.labels.pause : this.labels.play);
              }
            };

            const syncMuteUi = (muted) => {
              wrap.classList.toggle('is-muted', muted);
              if (mute) {
                mute.setAttribute('aria-label', muted ? this.labels.unmute : this.labels.mute);
              }
            };

            const applyToGroup = (fn) => {
              this.wrapsForIndex(index).forEach(fn);
            };

            playback?.addEventListener('click', () => {
              const shouldPlay = video.paused;
              applyToGroup((item) => {
                const media = item.querySelector('video');
                if (!media) return;
                if (shouldPlay) {
                  item.dataset.userPaused = '';
                  media.play().catch(() => {});
                } else {
                  item.dataset.userPaused = 'true';
                  media.pause();
                }
              });
            });

            mute?.addEventListener('click', () => {
              const shouldMute = !video.muted;
              applyToGroup((item) => {
                const media = item.querySelector('video');
                if (!media) return;
                media.muted = shouldMute;
                item.classList.toggle('is-muted', shouldMute);
                const btn = item.querySelector('[data-mute]');
                if (btn) {
                  btn.setAttribute('aria-label', shouldMute ? this.labels.unmute : this.labels.mute);
                }
              });
            });

            if (progress) {
              progress.addEventListener('pointerdown', (event) => {
                event.preventDefault();
                progress.setPointerCapture(event.pointerId);
                const duration = durationOf();
                if (!duration) return;
                const rect = progress.getBoundingClientRect();
                const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
                applyToGroup((item) => {
                  const media = item.querySelector('video');
                  if (media) media.currentTime = ratio * duration;
                });
                setProgress(ratio);
              });
              progress.addEventListener('pointermove', (event) => {
                if (!progress.hasPointerCapture(event.pointerId)) return;
                const duration = durationOf();
                if (!duration) return;
                const rect = progress.getBoundingClientRect();
                const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
                applyToGroup((item) => {
                  const media = item.querySelector('video');
                  if (media) media.currentTime = ratio * duration;
                });
                setProgress(ratio);
              });
              progress.addEventListener('keydown', (event) => {
                const duration = durationOf();
                if (!duration) return;
                const step = duration / 20;
                let next = video.currentTime;
                if (event.key === 'ArrowRight' || event.key === 'ArrowUp') next = Math.min(duration, next + step);
                else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') next = Math.max(0, next - step);
                else if (event.key === 'Home') next = 0;
                else if (event.key === 'End') next = duration;
                else return;
                event.preventDefault();
                applyToGroup((item) => {
                  const media = item.querySelector('video');
                  if (media) media.currentTime = next;
                });
                setProgress(next / duration);
              });
            }

            video.addEventListener('play', () => syncPlaybackUi(true));
            video.addEventListener('pause', () => syncPlaybackUi(false));
            video.addEventListener('volumechange', () => syncMuteUi(video.muted));

            video.play().then(() => syncPlaybackUi(true)).catch(() => syncPlaybackUi(false));
          });
        }

        syncProgress() {
          this.querySelectorAll('[data-video-wrap]').forEach((wrap) => {
            const video = wrap.querySelector('video');
            const fill = wrap.querySelector('[data-progress-fill]');
            const progress = wrap.querySelector('[data-progress]');
            if (!video || !fill) return;
            const duration = video.duration;
            if (!Number.isFinite(duration) || duration <= 0) return;
            const value = Math.min(1, Math.max(0, video.currentTime / duration));
            fill.style.setProperty('--progress', String(value));
            progress?.setAttribute('aria-valuenow', String(Math.round(value * 100)));
          });
        }

        keepVideosPlaying() {
          this.querySelectorAll('[data-video-wrap]').forEach((wrap) => {
            if (wrap.dataset.userPaused === 'true') return;
            const video = wrap.querySelector('video');
            if (video && video.paused) video.play().catch(() => {});
          });
        }
  }

  const tagName = 'about-slider';
  if (!customElements.get(tagName)) {
    customElements.define(tagName, AboutSlider);
  } else {
    const Prev = customElements.get(tagName);
    Object.getOwnPropertyNames(AboutSlider.prototype).forEach((key) => {
      if (key === 'constructor') return;
      Object.defineProperty(Prev.prototype, key, Object.getOwnPropertyDescriptor(AboutSlider.prototype, key));
    });
  }

  document.querySelectorAll(tagName).forEach((el) => {
    if (typeof el.startLoop === 'function') el.startLoop();
  });

  if (!window.__peralbaAboutSliderEvents) {
    window.__peralbaAboutSliderEvents = true;
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll(tagName).forEach((el) => {
        if (typeof el.init === 'function') el.init();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.stop();
      this.unbind();
    }

    init() {
      this.stop();
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.track.querySelectorAll('[data-clone]').forEach((node) => node.remove());
      this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));
      this.count = this.slides.length;
      this.index = 0;
      this.hovering = false;
      this.holding = false;
      this.intervalMs = Number(this.dataset.interval) || 4000;
      if (!this.reduced) {
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      }

      this.bind();
      this.prepareLoop();
      this.goTo(0, true);
      this.start();
    }

    bind() {
      if (this.bound) return;
      this.bound = true;
      this.onEnter = this.onEnter.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.onVisibility = this.onVisibility.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);
      this.onMotionChange = this.onMotionChange.bind(this);
      this.onResize = this.onResize.bind(this);
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      this.addEventListener('focusin', this.onEnter);
      this.addEventListener('focusout', this.onLeave);
      this.track.addEventListener('transitionend', this.onTransitionEnd);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.reduced.addEventListener('change', this.onMotionChange);
      window.addEventListener('resize', this.onResize);
    }

    unbind() {
      if (!this.bound) return;
      this.bound = false;
      this.removeEventListener('mouseenter', this.onEnter);
      this.removeEventListener('mouseleave', this.onLeave);
      this.removeEventListener('focusin', this.onEnter);
      this.removeEventListener('focusout', this.onLeave);
      this.track?.removeEventListener('transitionend', this.onTransitionEnd);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.reduced?.removeEventListener('change', this.onMotionChange);
      window.removeEventListener('resize', this.onResize);
    }

    prepareLoop() {
      if (this.count < 2) return;
      const clone = this.slides[0].cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.removeAttribute('data-index');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      Array.from(clone.attributes).forEach((attr) => {
        if (attr.name.includes('shopify')) clone.removeAttribute(attr.name);
      });
      this.track.appendChild(clone);
    }

    get autoplayEnabled() {
      return this.dataset.autoplay === 'true' && this.count > 1;
    }

    start() {
      this.stop();
      if (!this.autoplayEnabled || this.hovering || this.holding) return;
      if (document.hidden) return;
      this.timer = window.setInterval(() => this.next(), this.intervalMs);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      this.goTo(this.index + 1);
    }

    goTo(index, instant) {
      if (this.count < 2) {
        this.syncSlides(0);
        return;
      }

      const animate = !instant && !this.reduced.matches;
      const width = this.viewport?.clientWidth || this.offsetWidth;
      this.classList.toggle('is-animated', animate);
      this.index = index;
      this.track.style.transform = `translate3d(${-index * width}px, 0, 0)`;
      this.syncSlides(index >= this.count ? 0 : index);

      if (!animate && index >= this.count) {
        this.goTo(0, true);
      }
    }

    onTransitionEnd(event) {
      if (event.target !== this.track) return;
      if (event.propertyName !== 'transform') return;
      if (this.index < this.count) return;
      this.goTo(0, true);
    }

    syncSlides(activeIndex) {
      this.slides.forEach((slide, i) => {
        const on = i === activeIndex;
        slide.toggleAttribute('inert', !on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }

    onEnter() {
      this.hovering = true;
      this.stop();
    }

    onLeave(event) {
      if (event.relatedTarget && this.contains(event.relatedTarget)) return;
      this.hovering = false;
      this.start();
    }

    onResize() {
      this.goTo(this.index >= this.count ? 0 : this.index, true);
    }

    onVisibility() {
      if (document.hidden) this.stop();
      else this.start();
    }

    onMotionChange() {
      this.goTo(this.index >= this.count ? 0 : this.index, true);
      this.start();
    }

    hold(index) {
      this.holding = true;
      this.stop();
      this.goTo(index, true);
    }

    release() {
      this.holding = false;
      this.start();
    }
  }

  const tagName = 'announcement-bar';
  if (!customElements.get(tagName)) {
    customElements.define(tagName, AnnouncementBar);
  } else {
    const Prev = customElements.get(tagName);
    Object.getOwnPropertyNames(AnnouncementBar.prototype).forEach((key) => {
      if (key === 'constructor') return;
      Object.defineProperty(Prev.prototype, key, Object.getOwnPropertyDescriptor(AnnouncementBar.prototype, key));
    });
  }

  document.querySelectorAll(tagName).forEach((el) => {
    if (typeof el.init === 'function') el.init();
  });

  if (!window.__peralbaAnnouncementBarEvents) {
    window.__peralbaAnnouncementBarEvents = true;
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll(tagName).forEach((el) => {
        if (typeof el.init === 'function') el.init();
      });
    });
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-slide]');
      const bar = event.target.closest(tagName);
      if (!bar || !slide || typeof bar.hold !== 'function') return;
      bar.hold(Number(slide.dataset.index) || 0);
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const bar = event.target.closest(tagName);
      if (bar && typeof bar.release === 'function') bar.release();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const generation = (window.__peralbaCartDrawerGen = (window.__peralbaCartDrawerGen || 0) + 1);
    const isCurrent = () => window.__peralbaCartDrawerGen === generation;

    const DURATION = 450;
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const routesRoot = () =>
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const getDrawer = () => document.querySelector('[data-cart-drawer]');

    const resetPanelMotion = (panel) => {
      if (!panel) return;
      panel.getAnimations().forEach((animation) => animation.cancel());
      panel.style.removeProperty('transition');
      panel.style.removeProperty('transform');
    };

    const finishAnimation = (animation, panel, transform) => {
      try {
        animation.commitStyles();
      } catch (error) {
        panel.style.transform = transform;
      }
      animation.cancel();
    };

    const slidePanel = async (panel, from, to) => {
      if (!panel) return;
      resetPanelMotion(panel);

      if (reducedMotion()) {
        panel.style.transform = to;
        return;
      }

      panel.style.transform = from;
      void panel.offsetWidth;

      const animation = panel.animate([{ transform: from }, { transform: to }], {
        duration: DURATION,
        easing: 'ease-in-out',
        fill: 'forwards',
      });
      animation.pause();

      await new Promise((resolve) => {
        const start = performance.now();
        const tick = () => {
          if (!isCurrent()) {
            resolve();
            return;
          }
          const elapsed = Math.min(DURATION, performance.now() - start);
          try {
            animation.currentTime = elapsed;
          } catch (error) {
            resolve();
            return;
          }
          if (elapsed >= DURATION) resolve();
          else setTimeout(tick, 16);
        };
        tick();
      });

      finishAnimation(animation, panel, to);
    };

    const updateHeaderCount = (count) => {
      const n = Number(count) || 0;
      document.querySelectorAll('.header__cart-link, .header__icon--cart').forEach((el) => {
        if (n > 0) el.setAttribute('data-cart-filled', '');
        else el.removeAttribute('data-cart-filled');
      });
      document.querySelectorAll('.header__cart-bubble').forEach((bubble) => {
        if (n === 0) {
          bubble.classList.add('header__cart-bubble--empty');
          bubble.classList.remove('is-hidden');
          bubble.querySelector('.header__cart-count')?.remove();
          return;
        }
        bubble.classList.remove('is-hidden', 'header__cart-bubble--empty');
        let countEl = bubble.querySelector('.header__cart-count');
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'header__cart-count';
          bubble.appendChild(countEl);
        }
        countEl.textContent = String(n);
      });
    };

    const syncHeaderCount = async (fallbackCount) => {
      if (typeof fallbackCount !== 'undefined' && fallbackCount !== null) {
        updateHeaderCount(fallbackCount);
        return;
      }
      try {
        const response = await fetch(`${routesRoot()}cart.js`);
        if (!response.ok) return;
        const cart = await response.json();
        updateHeaderCount(cart.item_count);
      } catch (error) {
        console.error(error);
      }
    };

    const replaceContents = (html) => {
      const drawer = getDrawer();
      const target = drawer?.querySelector('[data-cart-drawer-contents]');
      if (!drawer || !target || !html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-cart-drawer-contents]');
      if (!next) return;
      target.replaceWith(next);
    };

    const refreshFromSections = (sections) => {
      const drawer = getDrawer();
      const sectionId = drawer?.dataset.sectionId;
      if (!sectionId || !sections?.[sectionId]) return;
      replaceContents(sections[sectionId]);
    };

    const fetchCartSections = async () => {
      const drawer = getDrawer();
      const sectionId = drawer?.dataset.sectionId;
      if (!sectionId) return null;
      const response = await fetch(`${routesRoot()}?sections=${encodeURIComponent(sectionId)}`);
      if (!response.ok) throw new Error('Section render failed');
      return response.json();
    };

    const cartRequest = async (path, body) => {
      const drawer = getDrawer();
      const sectionId = drawer?.dataset.sectionId;
      const payload = { ...body };
      if (sectionId) payload.sections = sectionId;
      const response = await fetch(`${routesRoot()}${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const error = new Error(data.description || data.message || 'Cart request failed');
        error.payload = data;
        throw error;
      }
      return data;
    };

    const setScrollLockCompensation = (enabled) => {
      if (!enabled) {
        document.documentElement.style.removeProperty('--scroll-lock-compensation');
        return;
      }
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty(
        '--scroll-lock-compensation',
        `${Math.max(0, scrollbarWidth)}px`
      );
    };

    const openDrawer = async ({ refresh = false } = {}) => {
      if (!isCurrent()) return;
      const drawer = getDrawer();
      if (!drawer || typeof drawer.showModal !== 'function') return;

      const releaseDialogFocus = () => {
        if (drawer.tabIndex < 0) drawer.tabIndex = -1;
        drawer.focus({ preventScroll: true });
      };

      const refreshCart = async () => {
        if (!refresh) return;
        try {
          refreshFromSections(await fetchCartSections());
        } catch (error) {
          console.error(error);
        }
      };

      const panel = drawer.querySelector('[data-cart-drawer-panel]');

      if (drawer.dataset.closing === 'true') {
        delete drawer.dataset.closing;
        drawer.classList.remove('is-closing');
        drawer.classList.add('is-open');
        await slidePanel(panel, 'translateX(100%)', 'translateX(0)');
        await refreshCart();
        document.dispatchEvent(new CustomEvent('cart:opened'));
        return;
      }

      if (drawer.open) {
        drawer.classList.remove('is-closing');
        drawer.classList.add('is-open');
        await refreshCart();
        document.dispatchEvent(new CustomEvent('cart:opened'));
        return;
      }

      setScrollLockCompensation(true);
      drawer.setAttribute('scroll-lock', '');
      drawer.classList.remove('is-closing', 'is-open');
      resetPanelMotion(panel);
      if (panel) panel.style.transform = 'translateX(100%)';
      drawer.showModal();
      releaseDialogFocus();
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      await Promise.all([slidePanel(panel, 'translateX(100%)', 'translateX(0)'), refreshCart()]);
      document.dispatchEvent(new CustomEvent('cart:opened'));
    };

    const closeDrawer = async () => {
      if (!isCurrent()) return;
      const drawer = getDrawer();
      if (!drawer?.open || drawer.dataset.closing === 'true') return;

      const panel = drawer.querySelector('[data-cart-drawer-panel]');
      drawer.dataset.closing = 'true';
      drawer.classList.add('is-closing');

      await slidePanel(panel, 'translateX(0)', 'translateX(100%)');
      if (!isCurrent()) return;

      resetPanelMotion(panel);
      drawer.classList.remove('is-open', 'is-closing');
      drawer.close();
      drawer.removeAttribute('scroll-lock');
      setScrollLockCompensation(false);
      delete drawer.dataset.closing;
    };

    document.addEventListener('cancel', (event) => {
      if (!isCurrent()) return;
      const drawer = getDrawer();
      if (event.target !== drawer) return;
      event.preventDefault();
      closeDrawer();
    });

    document.addEventListener('click', async (event) => {
      if (!isCurrent()) return;

      const openTrigger = event.target.closest('[data-cart-drawer-open]');
      if (openTrigger) {
        event.preventDefault();
        openDrawer({ refresh: true });
        return;
      }

      const drawer = getDrawer();
      if (!drawer) return;

      const closeBtn = event.target.closest('[data-cart-drawer-close]');
      if (closeBtn && drawer.contains(closeBtn)) {
        closeDrawer();
        return;
      }

      if (drawer.open) {
        const panel = drawer.querySelector('[data-cart-drawer-panel]');
        if (!panel || !panel.contains(event.target)) {
          closeDrawer();
          return;
        }
      }

      const qtyBtn = event.target.closest('[data-cart-qty-change]');
      if (qtyBtn && drawer.contains(qtyBtn)) {
        const key = qtyBtn.getAttribute('data-line-key');
        const quantity = Number(qtyBtn.getAttribute('data-quantity'));
        if (!key || Number.isNaN(quantity)) return;
        qtyBtn.disabled = true;
        try {
          const data = await cartRequest('cart/change.js', { id: key, quantity });
          refreshFromSections(data.sections);
          await syncHeaderCount(data.item_count);
        } catch (error) {
          console.error(error);
        } finally {
          qtyBtn.disabled = false;
        }
        return;
      }

      const noteSave = event.target.closest('[data-cart-note-save]');
      if (noteSave && drawer.contains(noteSave)) {
        const note = drawer.querySelector('[data-cart-note]')?.value || '';
        noteSave.disabled = true;
        try {
          const data = await cartRequest('cart/update.js', { note });
          refreshFromSections(data.sections);
          await syncHeaderCount(data.item_count);
        } catch (error) {
          console.error(error);
        } finally {
          noteSave.disabled = false;
        }
        return;
      }

      const discountApply = event.target.closest('[data-cart-discount-apply]');
      if (discountApply && drawer.contains(discountApply)) {
        const input = drawer.querySelector('[data-cart-discount-input]');
        const status = drawer.querySelector('[data-cart-discount-status]');
        const code = (input?.value || '').trim();
        if (!code) return;
        discountApply.disabled = true;
        if (status) {
          status.hidden = true;
          status.textContent = '';
        }
        try {
          const data = await cartRequest('cart/update.js', { discount: code });
          refreshFromSections(data.sections);
          await syncHeaderCount(data.item_count);
        } catch (error) {
          if (status) {
            status.hidden = false;
            status.textContent =
              (error.payload && (error.payload.description || error.payload.message)) ||
              status.dataset.errorMessage ||
              '';
          }
        } finally {
          discountApply.disabled = false;
        }
      }
    });

    document.addEventListener('cart:item-added', async (event) => {
      if (!isCurrent()) return;
      const detail = event.detail || {};
      if (detail.sections) refreshFromSections(detail.sections);
      else {
        try {
          refreshFromSections(await fetchCartSections());
        } catch (error) {
          console.error(error);
        }
      }
      await syncHeaderCount(detail.item_count);
      openDrawer();
    });

    document.addEventListener('cart:open', () => {
      if (!isCurrent()) return;
      openDrawer({ refresh: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__peralbaFaqLd) return;
    window.__peralbaFaqLd = true;

    var mount = function () {
      if (document.querySelector('script[data-faq-page]')) return;

      var items = document.querySelectorAll('[data-faq-question]');
      if (!items.length) return;

      var mainEntity = [];
      for (var i = 0; i < items.length; i += 1) {
        var question = items[i].getAttribute('data-faq-question');
        var answer = items[i].getAttribute('data-faq-answer');
        if (!question || !answer) continue;
        mainEntity.push({
          '@type': 'Question',
          name: question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answer,
          },
        });
      }

      if (!mainEntity.length) return;

      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-faq-page', '');
      script.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: mainEntity,
      });
      document.head.appendChild(script);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount);
    } else {
      mount();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-footer]');
    if (!root) return;

    const fitLocaleSelect = (select) => {
      const option = select.options[select.selectedIndex];
      if (!option) return;

      const probe = document.createElement('span');
      const style = getComputedStyle(select);
      probe.textContent = option.text;
      probe.style.cssText = [
        'position:absolute',
        'left:-9999px',
        'top:0',
        'visibility:hidden',
        'white-space:nowrap',
        `font:${style.font}`,
        `letter-spacing:${style.letterSpacing}`,
        `text-transform:${style.textTransform}`,
      ].join(';');
      document.body.append(probe);
      const pad =
        (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
      select.style.width = `${Math.ceil(probe.getBoundingClientRect().width + pad)}px`;
      probe.remove();
    };

    root.querySelectorAll('[data-footer-locale]').forEach((select) => {
      fitLocaleSelect(select);
      select.addEventListener('change', () => {
        fitLocaleSelect(select);
        if (select.form) select.form.submit();
      });
    });

    const lists = root.querySelectorAll('details.footer__linklist');
    if (!lists.length) return;

    const desktop = window.matchMedia('(min-width: 990px)');
    const syncLists = () => {
      lists.forEach((item) => {
        item.open = desktop.matches;
      });
    };

    if (desktop.addEventListener) {
      desktop.addEventListener('change', syncLists);
    } else {
      desktop.addListener(syncLists);
    }

    syncLists();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-header]');
    const spacer = document.querySelector('[data-header-spacer]');
    if (!header || !spacer) return;

    const dialogs = {
      search: header.querySelector('[data-header-dialog="search"]'),
      menu: header.querySelector('[data-header-dialog="menu"]'),
    };

    const SEARCH_DURATION = 450;
    const MENU_FROM = 'translateX(-100%)';
    const MENU_TO = 'translateX(0)';
    const menuButton = header.querySelector('[data-header-open="menu"]');
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const releaseDialogFocus = (dialog) => {
      if (!dialog) return;
      if (dialog.tabIndex < 0) dialog.tabIndex = -1;
      dialog.focus({ preventScroll: true });
    };

    const resetPanelMotion = (panel) => {
      if (!panel) return;
      panel.getAnimations().forEach((animation) => animation.cancel());
      panel.style.removeProperty('transform');
    };

    const finishAnimation = (animation, panel, transform) => {
      try {
        animation.commitStyles();
      } catch (error) {
        panel.style.transform = transform;
      }
      animation.cancel();
    };

    const slidePanel = async (panel, from, to) => {
      if (!panel) return;
      resetPanelMotion(panel);

      if (reducedMotion()) {
        panel.style.transform = to;
        return;
      }

      panel.style.transform = from;
      void panel.offsetWidth;

      const animation = panel.animate([{ transform: from }, { transform: to }], {
        duration: SEARCH_DURATION,
        easing: 'ease-in-out',
        fill: 'forwards',
      });

      await animation.finished.catch(() => {});
      finishAnimation(animation, panel, to);
    };

    const searchForm = dialogs.search?.querySelector('[data-predictive-search]');
    const searchInput = searchForm?.querySelector('input[type="search"]');
    const resultsRoot = dialogs.search?.querySelector('[data-search-results]');
    const statusEl = dialogs.search?.querySelector('[data-search-status]');
    const predictiveUrl = resultsRoot?.dataset.predictiveUrl;
    const predictiveSection = resultsRoot?.dataset.predictiveSection;
    let predictiveAbort = null;
    let predictiveTimer = 0;

    const setSearchExpanded = (expanded) => {
      searchInput?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    };

    const hidePredictive = () => {
      if (predictiveAbort) {
        predictiveAbort.abort();
        predictiveAbort = null;
      }
      if (!resultsRoot) return;
      resultsRoot.hidden = true;
      resultsRoot.innerHTML = '';
      resultsRoot.removeAttribute('aria-busy');
      setSearchExpanded(false);
      if (statusEl) statusEl.textContent = '';
    };

    const resetPredictive = () => {
      window.clearTimeout(predictiveTimer);
      if (searchInput) searchInput.value = '';
      hidePredictive();
    };

    const showDefaultResults = () => {
      window.clearTimeout(predictiveTimer);
      hidePredictive();
    };

    const applyPredictiveMarkup = (html) => {
      if (!resultsRoot) return;
      const results = new DOMParser().parseFromString(html, 'text/html').querySelector('#predictive-search-results');
      resultsRoot.innerHTML = results
        ? results.innerHTML
        : `<p class="header__search-empty">${resultsRoot.dataset.emptyMessage || ''}</p>`;
      resultsRoot.hidden = false;
      resultsRoot.removeAttribute('aria-busy');
      setSearchExpanded(true);
      const status = resultsRoot.querySelector('[data-search-status]');
      if (statusEl) {
        statusEl.textContent = status
          ? status.textContent.trim()
          : resultsRoot.dataset.emptyMessage || '';
      }
    };

    const fetchPredictive = (query) => {
      if (!predictiveUrl || !predictiveSection || !resultsRoot) return;
      if (predictiveAbort) predictiveAbort.abort();
      const controller = new AbortController();
      predictiveAbort = controller;
      resultsRoot.setAttribute('aria-busy', 'true');

      const url = new URL(predictiveUrl, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '8');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('section_id', predictiveSection);

      fetch(url, { signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then((text) => {
          if (controller.signal.aborted) return;
          applyPredictiveMarkup(text);
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          resultsRoot.removeAttribute('aria-busy');
        });
    };

    const onSearchInput = (event) => {
      const query = event.target.value.trim();
      window.clearTimeout(predictiveTimer);
      if (!query) {
        showDefaultResults();
        return;
      }
      predictiveTimer = window.setTimeout(() => fetchPredictive(query), 250);
    };

    searchInput?.addEventListener('input', onSearchInput);

    const openSearch = async (dialog) => {
      const panel = dialog.querySelector('.header__search-panel');
      const focusInput = () => {
        const input = dialog.querySelector('input[type="search"]');
        if (input) input.focus();
        const query = searchInput?.value.trim();
        if (query) fetchPredictive(query);
      };

      if (dialog.dataset.closing === 'true') {
        delete dialog.dataset.closing;
        dialog.classList.remove('is-closing');
        dialog.classList.add('is-open');
        await slidePanel(panel, 'translateY(-100%)', 'translateY(0)');
        focusInput();
        return;
      }

      if (dialog.open) {
        dialog.classList.remove('is-closing');
        dialog.classList.add('is-open');
        focusInput();
        return;
      }

      dialog.setAttribute('scroll-lock', '');
      dialog.classList.remove('is-closing', 'is-open');
      resetPanelMotion(panel);
      if (panel) panel.style.transform = 'translateY(-100%)';
      dialog.showModal();
      void dialog.offsetWidth;
      dialog.classList.add('is-open');
      await slidePanel(panel, 'translateY(-100%)', 'translateY(0)');
      focusInput();
    };

    const closeSearch = async (dialog) => {
      if (!dialog?.open || dialog.dataset.closing === 'true') return;

      const panel = dialog.querySelector('.header__search-panel');
      dialog.dataset.closing = 'true';
      dialog.classList.add('is-closing');

      await slidePanel(panel, 'translateY(0)', 'translateY(-100%)');
      if (dialog.dataset.closing !== 'true') return;

      resetPanelMotion(panel);
      dialog.classList.remove('is-open', 'is-closing');
      dialog.close();
      dialog.removeAttribute('scroll-lock');
      delete dialog.dataset.closing;
      resetPredictive();
    };

    const setMenuExpanded = (open) => {
      if (menuButton) menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const openMenu = async (dialog) => {
      const panel = dialog.querySelector('[data-header-drawer-panel]');

      if (dialog.dataset.closing === 'true') {
        delete dialog.dataset.closing;
        dialog.classList.remove('is-closing');
        dialog.classList.add('is-open');
        setMenuExpanded(true);
        await slidePanel(panel, MENU_FROM, MENU_TO);
        return;
      }

      if (dialog.open) {
        dialog.classList.remove('is-closing');
        dialog.classList.add('is-open');
        setMenuExpanded(true);
        return;
      }

      dialog.setAttribute('scroll-lock', '');
      dialog.classList.remove('is-closing', 'is-open');
      resetPanelMotion(panel);
      if (panel) panel.style.transform = MENU_FROM;
      dialog.showModal();
      releaseDialogFocus(dialog);
      void dialog.offsetWidth;
      dialog.classList.add('is-open');
      setMenuExpanded(true);
      await slidePanel(panel, MENU_FROM, MENU_TO);
    };

    const closeMenu = async (dialog) => {
      if (!dialog?.open || dialog.dataset.closing === 'true') return;

      const panel = dialog.querySelector('[data-header-drawer-panel]');
      dialog.dataset.closing = 'true';
      dialog.classList.add('is-closing');

      await slidePanel(panel, MENU_TO, MENU_FROM);
      if (dialog.dataset.closing !== 'true') return;

      resetPanelMotion(panel);
      dialog.classList.remove('is-open', 'is-closing');
      dialog.close();
      dialog.removeAttribute('scroll-lock');
      delete dialog.dataset.closing;
      setMenuExpanded(false);
    };

    const openDialog = (name) => {
      const dialog = dialogs[name];
      if (!dialog || typeof dialog.showModal !== 'function') return;
      if (name === 'search') {
        openSearch(dialog);
        return;
      }
      if (name === 'menu') {
        openMenu(dialog);
        return;
      }
      dialog.setAttribute('scroll-lock', '');
      dialog.showModal();
    };

    const closeDialog = (dialog) => {
      if (!dialog?.open) return;
      if (dialog === dialogs.search) {
        closeSearch(dialog);
        return;
      }
      if (dialog === dialogs.menu) {
        closeMenu(dialog);
        return;
      }
      dialog.close();
      dialog.removeAttribute('scroll-lock');
    };

    header.querySelectorAll('[data-header-open]').forEach((button) => {
      button.addEventListener('click', () => openDialog(button.getAttribute('data-header-open')));
    });

    header.querySelectorAll('[data-header-close]').forEach((button) => {
      button.addEventListener('click', () => closeDialog(button.closest('dialog')));
    });

    Object.values(dialogs).forEach((dialog) => {
      if (!dialog) return;
      dialog.addEventListener('click', (event) => {
        const panel = dialog.querySelector('.header__search-panel, .header__drawer-panel');
        if (!panel || !panel.contains(event.target)) closeDialog(dialog);
      });
    });

    dialogs.search?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeSearch(dialogs.search);
    });

    dialogs.menu?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeMenu(dialogs.menu);
    });

    const TOP_OFFSET = 8;
    let lastY = window.scrollY;
    let ticking = false;

    const setHeaderHeight = () => {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    };

    const setSpacerHeight = (fixed) => {
      setHeaderHeight();
      spacer.style.height = fixed ? `${header.offsetHeight}px` : '0px';
    };

    const setHeaderInset = () => {
      const visible =
        !header.classList.contains('is-hidden') &&
        (header.classList.contains('is-sticky') || header.classList.contains('is-mega-open'));
      const inset = visible ? header.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-inset', `${inset}px`);
    };

    const hero = header.hasAttribute('data-header-hero-overlay')
      ? document.querySelector('[data-hero]')
      : null;

    const heroOnScreen = () => hero && hero.getBoundingClientRect().bottom > 0;

    const commitWithoutMotion = (apply) => {
      header.classList.add('is-instant');
      apply();
      void header.offsetWidth;
      header.classList.remove('is-instant');
    };

    const pinOriginalHeader = (atTop) => {
      if (atTop) {
        if (
          header.classList.contains('is-fixed') ||
          header.classList.contains('is-sticky') ||
          header.classList.contains('is-hidden')
        ) {
          commitWithoutMotion(() => {
            header.classList.remove('is-hidden', 'is-sticky', 'is-fixed');
            setSpacerHeight(false);
          });
        }
        return;
      }

      if (!header.classList.contains('is-fixed') && header.getBoundingClientRect().top > 0) return;

      const showingOriginal =
        header.classList.contains('is-fixed') &&
        !header.classList.contains('is-hidden') &&
        !header.classList.contains('is-sticky');
      if (showingOriginal) return;

      commitWithoutMotion(() => {
        header.classList.add('is-fixed');
        header.classList.remove('is-hidden', 'is-sticky');
        setSpacerHeight(true);
      });
    };

    const syncHeader = () => {
      const y = window.scrollY;
      const delta = y - lastY;
      const atTop = y <= TOP_OFFSET;

      if (heroOnScreen()) {
        pinOriginalHeader(atTop);
        setHeaderInset();
        lastY = y;
        ticking = false;
        return;
      }

      if (
        header.classList.contains('is-fixed') &&
        !header.classList.contains('is-sticky') &&
        !header.classList.contains('is-hidden')
      ) {
        header.classList.add('is-hidden');
        setSpacerHeight(true);
        setHeaderInset();
        lastY = y;
        ticking = false;
        return;
      }

      if (atTop) {
        if (
          header.classList.contains('is-fixed') ||
          header.classList.contains('is-sticky') ||
          header.classList.contains('is-hidden')
        ) {
          commitWithoutMotion(() => {
            header.classList.remove('is-hidden', 'is-sticky', 'is-fixed');
            setSpacerHeight(false);
          });
        }
        setHeaderInset();
        lastY = y;
        ticking = false;
        return;
      }

      if (Math.abs(delta) < 4) {
        ticking = false;
        return;
      }

      const goingDown = delta > 0;
      const fixed = header.classList.contains('is-fixed');

      if (goingDown) {
        if (!fixed && header.getBoundingClientRect().bottom > 0) {
          lastY = y;
          ticking = false;
          return;
        }

        if (!fixed) {
          commitWithoutMotion(() => {
            header.classList.add('is-fixed', 'is-hidden');
            setSpacerHeight(true);
          });
        } else {
          header.classList.add('is-hidden');
          setSpacerHeight(true);
        }
      } else if (fixed || header.getBoundingClientRect().bottom <= 0) {
        header.classList.add('is-fixed', 'is-sticky');
        header.classList.remove('is-hidden');
        setSpacerHeight(true);
      }

      setHeaderInset();
      lastY = y;
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(syncHeader);
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      () => {
        if (header.classList.contains('is-fixed')) setSpacerHeight(true);
        else setHeaderHeight();
        setHeaderInset();
        if (window.matchMedia('(min-width: 990px)').matches && dialogs.menu?.open) {
          closeMenu(dialogs.menu);
        }
      },
      { passive: true }
    );

    const megaItems = header.querySelectorAll('[data-mega-item]');
    const MEGA_CLOSE_DELAY = 300;
    let megaCloseTimer = null;

    const setMegaOpen = (item, open) => {
      if (open) {
        clearTimeout(megaCloseTimer);
        megaCloseTimer = null;
        megaItems.forEach((el) => {
          const isThis = el === item;
          el.classList.toggle('is-open', isThis);
          el.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', isThis ? 'true' : 'false');
        });
        header.classList.add('is-mega-open');
        setHeaderInset();
        return;
      }

      clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(() => {
        item.classList.remove('is-open');
        item.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'false');
        const anyOpen = [...megaItems].some((el) => el.classList.contains('is-open'));
        header.classList.toggle('is-mega-open', anyOpen);
        setHeaderInset();
        megaCloseTimer = null;
      }, MEGA_CLOSE_DELAY);
    };

    megaItems.forEach((item) => {
      item.addEventListener('mouseenter', () => setMegaOpen(item, true));
      item.addEventListener('mouseleave', () => setMegaOpen(item, false));
      item.addEventListener('focusin', () => setMegaOpen(item, true));
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) setMegaOpen(item, false);
      });
    });

    setHeaderHeight();
    syncHeader();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.password');
    const dialog = document.querySelector('[data-password-modal]');
    if (!root || !dialog || typeof dialog.showModal !== 'function') return;

    const input = dialog.querySelector('[data-password-input]');
    const inner = dialog.querySelector('.password-modal__inner');
    const forceOpen = Boolean(dialog.querySelector('[data-password-force-open]'));

    const open = () => {
      dialog.setAttribute('scroll-lock', '');
      if (!dialog.open) dialog.showModal();
      input?.focus();
    };

    const close = () => {
      if (!dialog.open) return;
      dialog.close();
    };

    root.querySelectorAll('[data-password-open]').forEach((button) => {
      button.addEventListener('click', () => open());
    });

    dialog.querySelectorAll('[data-password-close]').forEach((button) => {
      button.addEventListener('click', () => close());
    });

    dialog.addEventListener('click', (event) => {
      if (!inner || !inner.contains(event.target)) close();
    });

    dialog.addEventListener('close', () => {
      dialog.removeAttribute('scroll-lock');
    });

    if (forceOpen) open();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__peralbaReviewFonts) return;
    window.__peralbaReviewFonts = true;

    const CSS = `#reviews,#reviews *{font-family:var(--font-primary--family)!important}#reviews .jdgm-star{font-family:"JudgemeStar"!important}#reviews [class*="jdgm-icon"]{font-family:"JudgemeIcons"!important}`;

    const inject = () => {
      let tag = document.getElementById('peralba-jdgm-fonts');
      if (!tag) {
        tag = document.createElement('style');
        tag.id = 'peralba-jdgm-fonts';
        document.head.appendChild(tag);
      }
      tag.textContent = CSS;
    };

    inject();
    document.addEventListener('jdgm.doneInjecting', inject);
    document.addEventListener('jdgm.updated', inject);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product]');
    if (!root) return;

    const media = root.querySelector('[data-product-media]');
    const progress = root.querySelector('[data-product-media-progress]');
    if (media && progress) {
      const updateMediaProgress = () => {
        const max = media.scrollWidth - media.clientWidth;
        const ratio = max > 0 ? media.scrollLeft / max : 0;
        const thumb = 60;
        const travel = Math.max(media.clientWidth - thumb, 0);
        progress.style.transform = `translateX(${ratio * travel}px)`;
      };
      media.addEventListener('scroll', updateMediaProgress, { passive: true });
      window.addEventListener('resize', updateMediaProgress);
      updateMediaProgress();
    }

    const DURATION = 450;
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isSizeSheet = () => window.matchMedia('(max-width: 989px)').matches;
    const releaseDialogFocus = (dialog) => {
      if (!dialog) return;
      if (dialog.tabIndex < 0) dialog.tabIndex = -1;
      dialog.focus({ preventScroll: true });
    };
    const routesRoot = () =>
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const resetPanelMotion = (el) => {
      if (!el) return;
      el.getAnimations().forEach((animation) => animation.cancel());
      el.style.removeProperty('transition');
      el.style.removeProperty('transform');
    };

    const finishAnimation = (animation, el, transform) => {
      try {
        animation.commitStyles();
      } catch (error) {
        el.style.transform = transform;
      }
      animation.cancel();
    };

    const slidePanel = async (el, from, to) => {
      if (!el) return;
      resetPanelMotion(el);
      if (reducedMotion()) {
        el.style.transform = to;
        return;
      }
      el.style.transform = from;
      void el.offsetWidth;
      const animation = el.animate([{ transform: from }, { transform: to }], {
        duration: DURATION,
        easing: 'ease-in-out',
        fill: 'forwards',
      });
      animation.pause();
      await new Promise((resolve) => {
        const start = performance.now();
        const tick = () => {
          const elapsed = Math.min(DURATION, performance.now() - start);
          try {
            animation.currentTime = elapsed;
          } catch (error) {
            resolve();
            return;
          }
          if (elapsed >= DURATION) resolve();
          else setTimeout(tick, 16);
        };
        tick();
      });
      finishAnimation(animation, el, to);
    };

    const setScrollLockCompensation = (enabled) => {
      if (!enabled) {
        document.documentElement.style.removeProperty('--scroll-lock-compensation');
        return;
      }
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty(
        '--scroll-lock-compensation',
        `${Math.max(0, scrollbarWidth)}px`
      );
    };

    const form = root.querySelector('[data-product-form]');
    const select = root.querySelector('[data-product-variant-select]');
    form?.classList.add('is-enhanced');
    if (select) {
      select.setAttribute('aria-hidden', 'true');
      select.tabIndex = -1;
      select.required = false;
    }
    const hiddenId = root.querySelector('[data-product-variant-id]');
    const atcButtons = root.querySelectorAll('[data-product-atc]');
    const atcLabels = root.querySelectorAll('[data-product-atc-label]');
    const priceEl = root.querySelector('[data-product-price]');
    const priceAmountEl = priceEl?.querySelector('[data-product-price-amount]');
    const compareEl = priceEl?.querySelector('[data-product-compare]');
    const compareAmountEl = priceEl?.querySelector('[data-product-compare-amount]');
    const saleLabelEl = priceEl?.querySelector('[data-product-price-sale-label]');
    const saleTag = root.querySelector('[data-product-sale-tag]');
    const saleTemplate = root.dataset.salePercentLabel || '-__%';

    const setSaleTag = (percent) => {
      if (!saleTag) return;
      const value = Number(percent);
      if (!value) {
        saleTag.hidden = true;
        saleTag.textContent = '';
        return;
      }
      saleTag.hidden = false;
      saleTag.textContent = saleTemplate.replace('__', String(value));
    };

    const setDisplayedPrice = (price, compare, discount) => {
      if (!price) return;
      if (priceAmountEl) priceAmountEl.textContent = price;
      const nextCompare = compare || '';
      if (compareAmountEl) compareAmountEl.textContent = nextCompare;
      if (compareEl) compareEl.hidden = nextCompare === '';
      priceEl.classList.toggle('is-sale', nextCompare !== '');
      if (saleLabelEl) saleLabelEl.hidden = nextCompare === '';
      setSaleTag(discount);
    };
    const status = root.querySelector('[data-product-status]');
    const sizes = root.querySelectorAll('[data-product-size]');
    const sizeModal = document.querySelector('[data-product-size-modal]');
    const sizeModalPanel = sizeModal?.querySelector('[data-product-size-modal-panel]');
    const labels = {
      selectSize: root.dataset.selectSize || 'Select Size',
      addToCart: root.dataset.addToCart || 'Add to cart',
      soldOut: root.dataset.soldOut || 'Sold out',
      adding: root.dataset.adding || 'Adding…',
      addError: root.dataset.addError || 'Could not add to cart',
      notifySuccess: root.dataset.notifySuccess || '',
      notifyError: root.dataset.notifyError || '',
      notifySubmitting: root.dataset.notifySubmitting || '',
    };
    const hasSize = root.dataset.hasSize === 'true';

    const setAtc = (text, disabled) => {
      atcLabels.forEach((el) => {
        el.textContent = text;
      });
      atcButtons.forEach((el) => {
        el.disabled = Boolean(disabled);
      });
    };

    const selectedSize = () => root.querySelector('[data-product-size].is-selected');

    const syncAtcFromSelection = () => {
      if (sizeModal && isSizeSheet() && (hasSize || select)) {
        setAtc(labels.selectSize, false);
        return;
      }
      if (hiddenId) {
        setAtc(labels.addToCart, hiddenId.value === '');
        return;
      }
      const current = selectedSize();
      const option = select?.selectedOptions?.[0];
      const available = current
        ? current.dataset.available === 'true'
        : option?.dataset.available === 'true';
      const value = current?.dataset.variantId || select?.value || '';
      if (!value || !available) {
        setAtc(hasSize ? labels.selectSize : labels.soldOut, !hasSize && !available);
        return;
      }
      setAtc(labels.addToCart, false);
    };

    const selectSize = (button) => {
      if (!button || button.dataset.available !== 'true') return;
      sizes.forEach((size) => {
        if (size.dataset.available !== 'true') {
          size.classList.remove('is-selected');
          return;
        }
        const on = size === button;
        size.classList.toggle('is-selected', on);
        size.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      const id = button.dataset.variantId || '';
      if (select && id) {
        select.value = id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setDisplayedPrice(button.dataset.price, button.dataset.comparePrice, button.dataset.discount);
      const url = new URL(window.location.href);
      if (id) url.searchParams.set('variant', id);
      else url.searchParams.delete('variant');
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      syncAtcFromSelection();
    };

    const notifyDialog = document.querySelector('[data-product-notify]');
    const notifyForm = notifyDialog?.querySelector('[data-product-notify-form]');
    const notifySize = notifyDialog?.querySelector('[data-product-notify-size]');
    const notifyEmail = notifyDialog?.querySelector('[data-product-notify-email]');
    const notifyStatus = notifyDialog?.querySelector('[data-product-notify-status]');
    const notifySubmit = notifyDialog?.querySelector('[data-product-notify-submit]');
    const stoqJson = root.querySelector('[data-product-stoq]');
    let stoqProduct = null;
    try {
      stoqProduct = stoqJson ? JSON.parse(stoqJson.textContent) : null;
    } catch (error) {
      stoqProduct = null;
    }

    const setNotifyStatus = (text) => {
      if (notifyStatus) notifyStatus.textContent = text || '';
    };

    const resetNotify = () => {
      notifyDialog?.classList.remove('is-success');
      setNotifyStatus('');
      if (notifySubmit) {
        notifySubmit.hidden = false;
        notifySubmit.disabled = false;
      }
    };

    const fillNotifySizes = () => {
      if (!notifySize || notifySize.options.length) return;
      sizes.forEach((button) => {
        if (button.dataset.available === 'true' || !button.dataset.variantId) return;
        const option = document.createElement('option');
        option.value = button.dataset.variantId;
        option.textContent =
          button.querySelector('.product__size-label')?.textContent?.trim() || button.dataset.variantId;
        notifySize.append(option);
      });
      if (notifySize.options.length || !stoqProduct?.variants) return;
      stoqProduct.variants.forEach((variant) => {
        if (variant.available) return;
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = stoqProduct.title || String(variant.id);
        notifySize.append(option);
      });
    };

    const closeNotify = () => {
      if (!notifyDialog?.open) return;
      notifyDialog.close();
      notifyDialog.removeAttribute('scroll-lock');
    };

    const openNotify = (variantId) => {
      if (!notifyDialog || typeof notifyDialog.showModal !== 'function') return;
      fillNotifySizes();
      resetNotify();
      if (notifySize && variantId) {
        const match = Array.from(notifySize.options).some((option) => option.value === String(variantId));
        if (match) notifySize.value = String(variantId);
      }
      notifyDialog.setAttribute('scroll-lock', '');
      if (!notifyDialog.open) notifyDialog.showModal();
      releaseDialogFocus(notifyDialog);
    };

    const openStoqModal = (variantId) => {
      const api = window._RestockRocket;
      if (!api || typeof api.openModal !== 'function') return false;
      if (stoqProduct) api.openModal(stoqProduct, String(variantId));
      else api.openModal();
      return true;
    };

    const submitNotify = async (email, variantId) => {
      const response = await fetch('https://app.stoqapp.com/api/v1/intents.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Shopify-Shop-Domain': root.dataset.shopDomain || '',
        },
        body: JSON.stringify({
          intent: {
            shopify_variant_id: Number(variantId),
            shopify_product_id: Number(root.dataset.productId),
            channel: 'email',
            quantity: 1,
            source: 'api',
          },
          customer: {
            email,
            country: root.dataset.country || '',
          },
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const message = Array.isArray(data.errors) ? data.errors[0] : '';
        throw new Error(message || labels.notifyError);
      }
      if (Array.isArray(data.errors) && data.errors.length) {
        throw new Error(data.errors[0] || labels.notifyError);
      }
    };

    sizes.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.dataset.available !== 'true') {
          openNotify(button.dataset.variantId);
          return;
        }
        selectSize(button);
      });
    });

    notifyDialog?.querySelectorAll('[data-product-notify-close]').forEach((button) => {
      button.addEventListener('click', () => closeNotify());
    });

    notifyDialog?.addEventListener('click', (event) => {
      const inner = notifyDialog.querySelector('.product-notify__inner');
      if (!inner || !inner.contains(event.target)) closeNotify();
    });

    notifyForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (notifyDialog?.classList.contains('is-success')) return;
      const variantId = notifySize?.value;
      const email = notifyEmail?.value?.trim();
      if (!variantId || !email) return;
      if (notifySubmit) notifySubmit.disabled = true;
      setNotifyStatus(labels.notifySubmitting);
      try {
        await submitNotify(email, variantId);
        notifyDialog?.classList.add('is-success');
        setNotifyStatus(labels.notifySuccess);
        if (notifySubmit) notifySubmit.hidden = true;
        if (notifyStatus) {
          notifyStatus.tabIndex = -1;
          notifyStatus.focus({ preventScroll: true });
        }
      } catch (error) {
        if (error instanceof TypeError && openStoqModal(variantId)) {
          closeNotify();
          return;
        }
        setNotifyStatus(error.message || labels.notifyError);
      } finally {
        if (notifySubmit && !notifyDialog?.classList.contains('is-success')) {
          notifySubmit.disabled = false;
        }
      }
    });

    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (option?.dataset.available === 'false') {
        select.value = '';
        syncAtcFromSelection();
        return;
      }
      setDisplayedPrice(option?.dataset.price, option?.dataset.comparePrice, option?.dataset.discount);
      sizes.forEach((size) => {
        if (size.dataset.available !== 'true') {
          size.classList.remove('is-selected');
          return;
        }
        const on = size.dataset.variantId === select.value;
        size.classList.toggle('is-selected', on);
        size.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      syncAtcFromSelection();
    });

    const addToCart = async (variantId) => {
      if (!variantId) return false;
      setAtc(labels.adding, true);

      try {
        const drawer = document.querySelector('[data-cart-drawer]');
        const sectionId = drawer?.dataset.sectionId;
        const payload = {
          items: [{ id: Number(variantId), quantity: 1 }],
        };
        if (sectionId) payload.sections = sectionId;

        const response = await fetch(`${routesRoot()}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error('Add to cart failed');
        const data = await response.json();
        document.dispatchEvent(
          new CustomEvent('cart:item-added', {
            detail: {
              item: data,
              sections: data.sections,
              item_count: data.item_count,
              source: 'product',
            },
          })
        );
        if (status) status.textContent = '';
        return true;
      } catch (error) {
        if (status) status.textContent = labels.addError;
        return false;
      } finally {
        syncAtcFromSelection();
      }
    };

    const closeSizeModal = async () => {
      if (!sizeModal?.open || sizeModal.dataset.closing === 'true') return;
      sizeModal.dataset.closing = 'true';
      sizeModal.classList.add('is-closing');
      await slidePanel(sizeModalPanel, 'translateY(0)', 'translateY(100%)');
      resetPanelMotion(sizeModalPanel);
      sizeModal.classList.remove('is-open', 'is-closing');
      sizeModal.close();
      sizeModal.removeAttribute('scroll-lock');
      setScrollLockCompensation(false);
      delete sizeModal.dataset.closing;
    };

    const openSizeModal = async () => {
      if (!sizeModal || typeof sizeModal.showModal !== 'function') return;
      if (sizeModal.dataset.closing === 'true') {
        delete sizeModal.dataset.closing;
        sizeModal.classList.remove('is-closing');
        sizeModal.classList.add('is-open');
        await slidePanel(sizeModalPanel, 'translateY(100%)', 'translateY(0)');
        return;
      }
      if (sizeModal.open) {
        sizeModal.classList.remove('is-closing');
        sizeModal.classList.add('is-open');
        return;
      }
      setScrollLockCompensation(true);
      sizeModal.setAttribute('scroll-lock', '');
      sizeModal.classList.remove('is-closing', 'is-open');
      resetPanelMotion(sizeModalPanel);
      if (sizeModalPanel) sizeModalPanel.style.transform = 'translateY(100%)';
      sizeModal.showModal();
      releaseDialogFocus(sizeModal);
      void sizeModal.offsetWidth;
      sizeModal.classList.add('is-open');
      await slidePanel(sizeModalPanel, 'translateY(100%)', 'translateY(0)');
    };

    atcButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        if (!(sizeModal && isSizeSheet() && (hasSize || select))) return;
        event.preventDefault();
        openSizeModal();
      });
    });

    form?.addEventListener('submit', async (event) => {
      if (sizeModal && isSizeSheet() && (hasSize || select)) {
        event.preventDefault();
        openSizeModal();
        return;
      }

      const variantInput = hiddenId || select;
      const variantId = variantInput?.value;
      if (!variantId) {
        event.preventDefault();
        sizes[0]?.focus();
        return;
      }
      const chosen = selectedSize();
      const option = select?.selectedOptions?.[0];
      const available = chosen
        ? chosen.dataset.available === 'true'
        : option?.dataset.available !== 'false';
      if (!available) {
        event.preventDefault();
        const firstAvailable = Array.from(sizes).find((size) => size.dataset.available === 'true');
        (firstAvailable || sizes[0])?.focus();
        return;
      }

      event.preventDefault();
      await addToCart(variantId);
    });

    sizeModal?.querySelectorAll('[data-product-size-modal-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;
        button.disabled = true;
        const sizeButton = Array.from(sizes).find((size) => size.dataset.variantId === variantId);
        if (sizeButton) selectSize(sizeButton);
        else if (select) {
          select.value = variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const adding = addToCart(variantId);
        await closeSizeModal();
        const added = await adding;
        if (!added) button.disabled = false;
      });
    });

    sizeModal?.querySelectorAll('[data-product-notify-open]').forEach((button) => {
      button.addEventListener('click', async () => {
        await closeSizeModal();
        openNotify(button.dataset.variantId);
      });
    });

    sizeModal?.querySelectorAll('[data-product-size-modal-close]').forEach((button) => {
      button.addEventListener('click', () => closeSizeModal());
    });

    sizeModal?.addEventListener('click', (event) => {
      if (!sizeModal.open) return;
      if (!sizeModalPanel || sizeModalPanel.contains(event.target)) return;
      closeSizeModal();
    });

    document.addEventListener('cancel', (event) => {
      if (event.target !== sizeModal) return;
      event.preventDefault();
      closeSizeModal();
    });

    window.addEventListener('resize', () => {
      if (sizeModal?.open && !isSizeSheet()) closeSizeModal();
      syncAtcFromSelection();
    });

    syncAtcFromSelection();

    const drawer = document.querySelector('[data-product-drawer]');
    if (!drawer || typeof drawer.showModal !== 'function') return;

    const panel = drawer.querySelector('[data-product-drawer-panel]');
    const tabs = drawer.querySelectorAll('[data-product-drawer-tab]');
    const panels = drawer.querySelectorAll('[data-product-drawer-panel-content]');

    const activateTab = (key) => {
      if (!key) return;
      let selected = null;
      tabs.forEach((tab) => {
        const on = tab.dataset.productDrawerTab === key;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on) selected = tab;
      });
      panels.forEach((content) => {
        const on = content.dataset.productDrawerPanelContent === key;
        content.hidden = !on;
      });
      selected?.scrollIntoView({
        inline: 'nearest',
        block: 'nearest',
        behavior: reducedMotion() ? 'auto' : 'smooth',
      });
    };

    const openDrawer = async (key) => {
      activateTab(key);
      if (drawer.dataset.closing === 'true') {
        delete drawer.dataset.closing;
        drawer.classList.remove('is-closing');
        drawer.classList.add('is-open');
        await slidePanel(panel, 'translateX(100%)', 'translateX(0)');
        return;
      }
      if (drawer.open) {
        drawer.classList.remove('is-closing');
        drawer.classList.add('is-open');
        return;
      }
      setScrollLockCompensation(true);
      drawer.setAttribute('scroll-lock', '');
      drawer.classList.remove('is-closing', 'is-open');
      resetPanelMotion(panel);
      if (panel) panel.style.transform = 'translateX(100%)';
      drawer.showModal();
      releaseDialogFocus(drawer);
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      await slidePanel(panel, 'translateX(100%)', 'translateX(0)');
    };

    const closeDrawer = async () => {
      if (!drawer.open || drawer.dataset.closing === 'true') return;
      drawer.dataset.closing = 'true';
      drawer.classList.add('is-closing');
      await slidePanel(panel, 'translateX(0)', 'translateX(100%)');
      resetPanelMotion(panel);
      drawer.classList.remove('is-open', 'is-closing');
      drawer.close();
      drawer.removeAttribute('scroll-lock');
      setScrollLockCompensation(false);
      delete drawer.dataset.closing;
    };

    document.addEventListener('cancel', (event) => {
      if (event.target !== drawer) return;
      event.preventDefault();
      closeDrawer();
    });

    document.addEventListener('click', (event) => {
      const openTrigger = event.target.closest('[data-product-drawer-open]');
      if (openTrigger) {
        event.preventDefault();
        openDrawer(openTrigger.getAttribute('data-product-drawer-open'));
        return;
      }

      const tab = event.target.closest('[data-product-drawer-tab]');
      if (tab && drawer.contains(tab)) {
        activateTab(tab.dataset.productDrawerTab);
        return;
      }

      const closeBtn = event.target.closest('[data-product-drawer-close]');
      if (closeBtn && drawer.contains(closeBtn)) {
        closeDrawer();
        return;
      }

      if (drawer.open) {
        const panel = drawer.querySelector('[data-product-drawer-panel]');
        if (!panel || !panel.contains(event.target)) closeDrawer();
      }
    });

    drawer.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      const enabled = Array.from(tabs);
      const current = enabled.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      if (current < 0) return;
      const delta = event.key === 'ArrowRight' ? 1 : -1;
      const next = enabled[(current + delta + enabled.length) % enabled.length];
      if (!next) return;
      event.preventDefault();
      activateTab(next.dataset.productDrawerTab);
      next.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__peralbaRelatedProducts) return;
    window.__peralbaRelatedProducts = true;

    const load = (el) => {
      const url = el.dataset.url;
      if (!url) return;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const doc = document.createElement('div');
          doc.innerHTML = text;
          const next = doc.querySelector('[data-related-products]');
          if (!next || !next.innerHTML.trim()) return;
          el.innerHTML = next.innerHTML;
          document.dispatchEvent(new CustomEvent('product-card:boot'));
        })
        .catch(() => {});
    };

    const watch = () => {
      document.querySelectorAll('[data-related-products]').forEach((el) => {
        if (el.dataset.loaded === 'true') return;
        el.dataset.loaded = 'true';
        if (!('IntersectionObserver' in window)) {
          load(el);
          return;
        }
        const observer = new IntersectionObserver(
          (entries, current) => {
            if (!entries[0] || !entries[0].isIntersecting) return;
            current.disconnect();
            load(el);
          },
          { rootMargin: '0px 0px 200px 0px' }
        );
        observer.observe(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch, { once: true });
    } else {
      watch();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
